'use strict';

function TimeOfDayBucketStateService() {
  var states = {};
  function setState(name, state) {
    states[name] = state;
  }
  function getState(name) {
    return states[name];
  }
  return {
    getState: getState,
    setState: setState
  };
}
TimeOfDayBucketStateService.$inject = [];
module.exports = TimeOfDayBucketStateService;